var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsNumber, IsString, IsUUID } from 'class-validator';
import { UpdatePreventionCourseModuleSectionDto } from './update-prevention-course-module-section.dto.js';
export class UpdatePreventionCourseModuleDto {
    id;
    title;
    description;
    totalDuration;
    availabilityDaysAfterEnrollment;
    preventionCourseModuleSections;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UpdatePreventionCourseModuleDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], UpdatePreventionCourseModuleDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], UpdatePreventionCourseModuleDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], UpdatePreventionCourseModuleDto.prototype, "totalDuration", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], UpdatePreventionCourseModuleDto.prototype, "availabilityDaysAfterEnrollment", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => UpdatePreventionCourseModuleSectionDto),
    __metadata("design:type", Array)
], UpdatePreventionCourseModuleDto.prototype, "preventionCourseModuleSections", void 0);
//# sourceMappingURL=update-prevention-course-module.dto.js.map